import { render, staticRenderFns } from "./ModattaSideModalLojaIntegrada.vue?vue&type=template&id=1cd31db7"
import script from "./ModattaSideModalLojaIntegrada.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalLojaIntegrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModattaSideModalLojaIntegrada.vue?vue&type=custom&index=0&blockType=styled&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports